class PreferredCultureDetector {
  type = 'languageDetector';

  init(services, detectorOptions, i18nextOptions) {
    this.detectorOptions = detectorOptions;
    this.services = services;
    this.i18nextOptions = i18nextOptions;
  }

  detect() {
    const { preferredCultures } = this.detectorOptions;
    const { resources = {} } = this.i18nextOptions;
    const { languageUtils } = this.services;
    const availableLanguages = Object.keys(resources).map(lng => languageUtils.getLanguagePartFromCode(lng));

    return (preferredCultures || [])
      .map(lng => languageUtils.getLanguagePartFromCode(lng))
      .find(lng => availableLanguages.indexOf(lng) > -1);
  }

  cacheUserLanguage = () => ({})
}

export default new PreferredCultureDetector();
